'use client';

import './styles/@theme';
import { SvgLoader } from '@/app/elements/svg/loader';
import type { SvgProps } from '@/types/svgs/svg-types';

type InfoPanelProps = {
    description: string[];
    iconsOptions?: SvgProps;
};

const defaultIconsOptions: SvgProps = {};

const Icons = (props: SvgProps) => [
    <SvgLoader iconName="site-wide-jackpot-toggle-on" directory="swj-icons" {...props} key="toggle-on" />,
    <SvgLoader iconName="site-wide-jackpot-trophy" directory="swj-icons" {...props} key="trophy" />,
    <SvgLoader iconName="site-wide-jackpot-slots" directory="swj-icons" {...props} key="slots" />,
    <SvgLoader iconName="site-wide-jackpot-toggle-off" directory="swj-icons" {...props} key="toggle-off" />
];

export const InfoPanel = ({ description, iconsOptions = defaultIconsOptions }: InfoPanelProps) => {
    return (
        <div className="info-panel">
            {description.map((item, index) => (
                <div className="info-panel__row" key={item}>
                    <div className="info-panel__row-icon">{Icons(iconsOptions)[index]}</div>
                    <span className="info-panel__row-text">{item}</span>
                </div>
            ))}
        </div>
    );
};
